module.exports = __webpack_public_path__ + "static/img/5.7fdf59e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/5.png
// module id = DKHk
// module chunks = 0